'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { use, useEffect } from 'react';
import UserPublicPersonaRooms from '@/app/[locale]/(worlds)/profile/[identifier]/components/UserPublicPersonaRooms';
import useHash from '@/hooks/useHash';
import { Room } from '@/services/cms';
type UserPersonaProps = {
  publicRoomsPromise: Promise<Room[]>;
};
function UserPersona(t0) {
  const $ = _c(15);
  const {
    publicRoomsPromise
  } = t0;
  const publicRooms = use(publicRoomsPromise);
  const hash = useHash();
  const t = useTranslations();
  let t1;
  if ($[0] !== hash || $[1] !== publicRooms.length) {
    t1 = () => {
      if (hash === "#persona" && publicRooms.length > 0) {
        const element = document.querySelector("#persona");
        if (!element) {
          return;
        }
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    };
    $[0] = hash;
    $[1] = publicRooms.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== hash || $[4] !== publicRooms) {
    t2 = [hash, publicRooms];
    $[3] = hash;
    $[4] = publicRooms;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (publicRooms.length === 0) {
    return null;
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("profile-page.anchors.persona");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <h2 className="subheader-1 md:header-4 relative mb-4 font-bold md:mb-6">{t3}</h2>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== publicRooms) {
    t5 = <UserPublicPersonaRooms publicRooms={publicRooms} />;
    $[10] = publicRooms;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <section id="persona" data-section="profile-persona" className="flex scroll-mt-36 flex-col justify-between px-4 md:px-8 lg:scroll-mt-40 lg:px-18">{t4}{t5}</section>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export default UserPersona;